import { useEffect, useState } from 'react';

import { CheckCircle } from '@mui/icons-material';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

interface WalletInvitationRedirectModalProps {
  open: boolean;
  ownerId: string;
  onRedirect: () => void;
}

export function WalletInvitationRedirectModal({
  open,
  ownerId,
  onRedirect,
}: WalletInvitationRedirectModalProps) {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (!open) {
      setCountdown(5);
      return;
    }

    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          onRedirect();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [open, onRedirect]);

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 2,
        },
      }}>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={2}>
          <CheckCircle sx={{ color: '#4caf50', fontSize: 40 }} />
          <Typography variant="h5" fontWeight={600}>
            Convite Aceito!
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={3}
          py={2}>
          <Typography variant="body1" textAlign="center" color="text.secondary">
            Seu convite foi confirmado com sucesso. Você será redirecionado para
            o ambiente de convidado.
          </Typography>

          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={2}
            mt={2}>
            <CircularProgress
              variant="determinate"
              value={(countdown / 5) * 100}
              size={80}
              thickness={4}
              sx={{
                color: '#1976d2',
              }}
            />
            <Typography variant="h4" fontWeight={700} color="primary">
              {countdown}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Redirecionando em {countdown} segundo{countdown !== 1 ? 's' : ''}
              ...
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
